import { type UseQueryResult } from '@tanstack/react-query';

import { useApiQuery } from '../../../lib/api/hooks.js';
import { queryKeys } from '../../../lib/api/query-keys.js';
import { reservationEndpoints } from './endpoints.js';
import { reservationDetail, type ReservationDetail } from './schemas.js';

/**
 * The full reservation record for the admin detail page.
 */
export function useReservation(reservationId: string): UseQueryResult<ReservationDetail> {
  return useApiQuery({
    queryKey: queryKeys.reservations.detail(reservationId),
    path: reservationEndpoints.fullDetail(reservationId),
    schema: reservationDetail,
    enabled: reservationId !== '',
  });
}
